<template>
  <div class="modal-upgrade popup-wrapper" @click.self="onClose" :class="{active}">
    <div class="bg" @click="onClose"></div>

    <div class="popup">
      <div class="close" @click="onClose">
        <i class="material-icons">close</i>
      </div>

      <div class="container form">
        <div class="main-title">Add a team member</div>

        <div class="inner">
          <div class="item" v-for="(item, index) in items" :key="index">
            <input type="email" v-model="items[index]" class="control" placeholder="Team Member Email"/>
            <a class="link-inverse" @click="handleDelete(index)" v-if="items.length > 1">
              <i class="material-icons">delete</i>
            </a>
          </div>

          <a class="add link-inverse" @click="handleAdd">Add a new member</a>

          <div class="hint">
            By adding the team member(s) above you agree to authorize the payment of $44.22. This is a prorated amount between now and the team’s anniversary date ($99.00 * .3 (4 months)). On the anniversary date, the card on file will be charged $99.00 for each active team member in this account.
          </div>

          <div class="inner">
            <a class="btn primary medium" @click="handleSubmit">Add member(s) & charge card</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import isEmail from 'validator/lib/isEmail';

export default {
  name: 'modal-team-add',
  props: {
    active: Boolean,
    onSubmit: Function,
    onClose: Function,
  },
  data() {
    return {
      items: [''],
    };
  },
  methods: {
    ...mapActions('notification', [
      'addNotification',
    ]),
    handleSubmit() {
      const models = [];

      this.items.forEach((el) => {
        if (el) {
          models.push({
            id: Math.random(),
            email: el,
          });
        }
      });

      this.onSubmit(models);
      this.items = [''];
    },
    handleDelete(index) {
      this.items.splice(index, 1);
    },
    handleAdd() {
      for (let i = 0; i < this.items.length; i++) {
        if (!isEmail(this.items[i])) {
          this.addNotification({ message: 'Emails are not valid!' });
          return;
        }
      }
      this.items.push('');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../styles/team';
</style>
